module.exports = __webpack_public_path__ + "assets/img/one-set-time.jpg";